// eslint-disable-next-line @typescript-eslint/no-var-requires
const CustomCategoryImage = require('./custom-category.png');

export const assets = {
  CustomCategoryImage,
};
